import { render, staticRenderFns } from "./DummyVGrid.vue?vue&type=template&id=fbc9523e&"
import script from "./DummyVGrid.vue?vue&type=script&lang=js&"
export * from "./DummyVGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports